import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Aktie } from '../entities/boerse/aktie.entity';
import { TradegateKurs } from '../entities/boerse/tradegatekurs.entity';
//#endregion

@Injectable()
export class TradegateKursService extends ODataEntityService<TradegateKurs> {
  constructor(protected client: ODataClient) {
    super(client, 'TradegateKurs', 'entities.boerse.TradegateKurs');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public aktie(entity: EntityKey<TradegateKurs>): ODataNavigationPropertyResource<Aktie> {
    return this.entity(entity).navigationProperty<Aktie>('aktie');
  }
  //#endregion
}
